import { isNullOrEmpty } from "../../../../../../../../../Common/TypingUtils";
import { isMatchAbbreviation } from "../Types";

import { FiasMunicipalDistrictTypes } from "./FiasMunicipalDistrictTypes";

export function getMunicipalDistrictTypeCode(municipalDistrict: string | number | undefined): string | undefined {
    const stringMunicipalDistrict = municipalDistrict?.toString();
    const FiasMunicipalDistrictTypesWithoutFT = [...FiasMunicipalDistrictTypes];
    FiasMunicipalDistrictTypesWithoutFT.pop();
    const municipalDistrictCode = FiasMunicipalDistrictTypesWithoutFT.find(abbreviation =>
        isMatchAbbreviation(abbreviation, stringMunicipalDistrict)
    )?.fiasKey?.toString();
    if (isNullOrEmpty(municipalDistrictCode)) {
        return undefined;
    }
    return municipalDistrictCode;
}

export function getMunicipalDistrictTypeCodeWithFT(municipalDistrict: string | number | undefined): string | undefined {
    const stringMunicipalDistrict = municipalDistrict?.toString();
    const municipalDistrictCode = FiasMunicipalDistrictTypes.find(abbreviation =>
        isMatchAbbreviation(abbreviation, stringMunicipalDistrict)
    )?.fiasKey?.toString();
    if (isNullOrEmpty(municipalDistrictCode)) {
        return undefined;
    }
    return municipalDistrictCode;
}

export function getMunicipalDistrictTypeShortName(municipalDistrict: string | number | undefined): string | undefined {
    const stringMunicipalDistrict = municipalDistrict?.toString();
    const municipalDistrictName = FiasMunicipalDistrictTypes.find(abbreviation =>
        isMatchAbbreviation(abbreviation, stringMunicipalDistrict)
    )?.short.toString();
    if (isNullOrEmpty(municipalDistrictName)) {
        return undefined;
    }
    return municipalDistrictName;
}
